import { useEffect } from "react";

interface MetaOptions {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  canonical?: string;
}

const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useDocumentMeta = ({
  title,
  description,
  ogTitle,
  ogDescription,
  canonical,
}: MetaOptions) => {
  useEffect(() => {
    const originalTitle = document.title;

    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    if (ogTitle) upsertMeta("property", "og:title", ogTitle);
    if (ogDescription) upsertMeta("property", "og:description", ogDescription);
    if (canonical) upsertCanonical(canonical);

    return () => {
      document.title = originalTitle;
    };
  }, [title, description, ogTitle, ogDescription, canonical]);
};
